export default __webpack_public_path__ + "static/media/baners-raceweek-750-330x330.3d605499.webp";